import React, { useState, useEffect } from 'react'
import '../Styles/Projects.css'
import Projectpop from '../components/Projectpop'
import axios from 'axios'
import { useNavigate } from 'react-router';
import Currency from '../components/Currency';
var temp = []
export default function Project() {
    const [data, setData] = useState([
        // { project_name: null, project_mebers: [], customer: 'name1 VeryLongName', flyaxavi_approved_coast: 450, cur: 'INR', no_of_resources: 10, status: 'TODO' },
    ])
    // const [temp,setTemp]=useState([])
    const check = async () => {
        // let temp = []
        let div1 = document.getElementById('optPnam').value
        let div2 = document.getElementById('optPmem').value
        let div3 = document.getElementById('optPAC').value
        let div4 = document.getElementById('optRES').value
        let div5 = document.getElementById('statop').value
        // let divs = [];
        // if (one) { temp.push(tempdat.filter((e) => e.status == 'TODO')); divs.push(addL('TODO')) }
        // if (two) { temp.push(tempdat.filter((e) => e.status == 'IN PROGRESS')); divs.push(addL('IN PROGRESS')) }
        // if (three) { temp.push(tempdat.filter((e) => e.status == 'COMPLETED')); divs.push(addL('COMPLETED')) }
        // temp = [].concat.apply([], temp);
        // if (!one && !two && !three) setData(tempdat)
        // else setData(temp)
        // div.appendChild(divs)http://127.0.0.1:8000/project/projects_filter/

        //-------------------------------------------------
        let query = {}
        query.project_name = div1.length == 0 ? '' : div1;
        query.project_location = div2.length == 0 ? '' : div2;
        query.status = div5;
        query.approx_start_date = div4;
        query.approx_duration = div3
        var form_data = new FormData();
        for (var key in query) {
            form_data.append(key, query[key]);
        }
        if (div1 != '' || div2 != '' || div5 != 'none' || div3 != 'none' || div4 != 'none')
            await axios({
                method: "post",
                url: `${process.env.REACT_APP_API_URL1}/project/projects_filter/`,
                data: form_data,
                headers: {
                    "Content-Type": "multipart/form-data",
                    'Authorization': `JWT ${localStorage.getItem('access')}`,
                    'Accept': 'application/json'
                },
            }).then(response => {
                console.log(div3.id)
                setData(response.data)
            }).catch(err => {
                console.log(err)
            })
        else getProjects(false)
        setFil({
            project_name: div1.length == 0 ? null : 'name : ' + div1,
            project_location: div2.length == 0 ? null : 'location : ' + div2,
            status: div5 != '' ? 'status : ' + div5 : null,
            approx_start_date: div4 != '' ? 'start : before ' + div4 : null,
            approx_duration: div3 != '' ? 'max duration : ' + div3 + ' months ' : null
        })
    }





    const getProjects = async (bol) => {
        await axios.get(`${process.env.REACT_APP_API_URL1}/${type == 'ACCOUNTANT' ? 'account/projects/' : type == 'CONSULTANT' ? 'consultant/projects/' : type == 'HR' ? 'hr/projects/' : 'project/projects/'}`, {
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `JWT ${localStorage.getItem('access')}`,
                'Accept': 'application/json'
            }
        })
            .then(async response => {
                setboler(true)
                temp = response.data.slice()
                // response.data=JSON.parse(response.data)
                console.log(response.data)
                // for (var option of document.getElementById("curselect").options) {
                //     if (option.value === curcur) {
                //         option.selected = true;
                //         break;
                //     }
                // }
                // setData(response.data.map((e) => {
                //     let currency=JSON.parse(localStorage.getItem('currency'))
                //     let dat = Object.assign({}, e)
                //     dat.flyaxavi_approved_coast=parseFloat((dat.flyaxavi_approved_coast/currency[curcur]).toFixed(2));
                //     return dat
                // }))
                setData(response.data)
                if (bol) {
                    let Pname = []
                    let Pmem = []
                    let PACa = []
                    let res = []
                    async function fun() {
                        for await (const dat of response.data) {
                            // Pname.push(dat.project_name)
                            // Pmem.push(dat.project_mebers.map((e) => { return e.first_name + " " + e.last_name + ", " }))
                            // Pmem.push(dat.project_location)
                            PACa.push(dat.approx_duration)
                            res.push(dat.approx_start_date)
                        }
                        // console.log([[Pname], [Pmem], [PACa], [res]])
                        return [
                            [...new Set(Pname)],
                            [...new Set(Pmem)],
                            [...new Set(PACa)],
                            [...new Set(res)]]
                    }
                    await fun().then(e => {
                        // let div1 = document.getElementById('optPnam')
                        // let div2 = document.getElementById('optPmem')
                        let div3 = document.getElementById('optPAC')
                        let div4 = document.getElementById('optRES')
                        // e[0].map(e => {
                        //     e ? div1.innerHTML += `<option value=${e}>${e}</option>` : console.log('nofil')
                        // })
                        // e[1].map(e => {
                        //     e ? div2.innerHTML += `<option value=${e} >${e}</option>` : console.log('nofil')
                        // })
                        e[2].map(e => {
                            e ? div3.innerHTML += `<option value=${e} >lessthan ${e} months</option>` : console.log('nofil')
                        })
                        e[3].map(e => {
                            e ? div4.innerHTML += `<option value=${e} >on or before ${e} </option>` : console.log('nofil')
                        })
                    });
                    bol = false
                }
                setLoad(false)
            }).catch(err => {
                setLoad(false)
                if (err.response.status == 500) {
                    try {
                        notify.innerHTML += `<div style="background-color:#f8d7da;color:#721c24" class='notifyUser'>
                        Server busy, Please try after some time
                        </div>`;
                        setTimeout(() => {
                            notify.removeChild(notify.lastChild)
                        }, 3000);
                    } catch (e) { console.log(e) }
                }
                let notify = document.getElementsByClassName('noti')[0];
                notify.innerHTML += `<div style="background-color:#f8d7da;color:#721c24" class='notifyUser'>
                                ${err.response.data.message}
                            </div>`;
                setTimeout(() => {
                    notify.removeChild(notify.lastChild)
                }, 3000);
                console.log(err)
            })
    }
    useEffect(async () => {
        if (!curcur) { curcur = 'INR'; localStorage.setItem('selectedCurrency', 'INR') }
        if (!symbol) { setSymbol('/-'); localStorage.setItem('symbol', '/-') }
        await getProjects(true);
    }, [])
    let navigate = useNavigate();
    function clear(id) {
        if (id == 'optPnam' || id == 'optPmem') {
            document.getElementById(id).value = ''; check(); return;
        }
        var elements = document.getElementById(id).options;
        for (var i = 0; i < elements.length; i++) {
            elements[i].selected = false;
        }
        check();
    }
    const Filtertag = (e) => {
        return <div className='filterBox'>
            {e.name}
            <i style={{
                cursor: 'pointer'
            }} onClick={() => { clear(e.id) }} class="fas fa-times"></i>
        </div>
    }
    const [filters, setFil] = useState({})
    const curCall = () => { }
    const [booler, setboler] = useState(false)
    var curcur = localStorage.getItem('selectedCurrency')
    const [symbol, setSymbol] = useState(localStorage.getItem('symbol'))
    function numberWithCommas(x) {
        return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    }
    let type = localStorage.getItem('type');
    const [hover, setHover] = useState(true);
    const [Eproj, setEproj] = useState(null)
    function TabRen() {
        const list = []
        for (let i = 0; i < 20; i++) {
            list.push(
                <tr>
                    <td class="loadingt">
                        <div class="bar"></div>
                    </td>
                    <td class="loadingt">
                        <div class="bar"></div>
                    </td>
                    <td class="loadingt">
                        <div class="bar"></div>
                    </td>
                    <td class="loadingt">
                        <div class="bar"></div>
                    </td>
                    <td class="loadingt">
                        <div class="bar"></div>
                    </td>
                </tr>
            )
        }
        return (
            <>
                {list}
            </>
        )
    }
    const [load, setLoad] = useState(true)
    return (
        <>
            <div className='showdet'>
                <div className='sticky'></div>
                <div className='sticky2'>
                    {type == 'PROJECT MANAGER' ? Eproj ? <Projectpop
                        call={getProjects}
                        data={Eproj} path='projects' /> : <Projectpop
                        call={getProjects}
                        // call={
                        //     getProjects
                        //     }
                        data={null} path='projects' /> : <></>}
                </div>
            </div>
            {booler ? <Currency callback={curCall} symbol={setSymbol} for='projects' ad={temp} data={data} setData={setData} /> : <></>}
            <div className='showdet filter showfil'>
                <div className='sticky'></div>
                <div className='sticky2'>
                    <div className='projDetI inputfix Projects'>
                        <i onClick={() => { document.getElementsByClassName('showfil')[0].classList.remove('show_hide') }} style={{ color: 'white', marginBottom: '30px' }} class="fas fa-times"></i>
                        <div> <span>Project Name  </span>
                            {/* <select id='optPnam'>
                                <option value="none">SELECT</option>
                            </select> */}
                            <input placeholder='type...' id='optPnam' />
                        </div>
                        <div> <span>Project Location  </span>
                            {/* <select id='optPmem'>
                                <option value="none">SELECT</option>
                            </select> */}
                            <input id='optPmem' placeholder='type...' />
                        </div>
                        <div> <span>Approx. Duration  </span>
                            <select id='optPAC'>
                                <option value="">SELECT</option>
                            </select>
                            {/* <input id='optPAC' /> */}
                        </div>
                        <div> <span>Start Date  </span>
                            <select id='optRES'>
                                <option value="">SELECT</option>
                            </select>
                            {/* <input id='optRES' /> */}
                        </div>
                        <div> <span>Stats  </span>
                            <select id='statop'>
                                <option value="">SELECT</option>
                                <option value="OPEN">OPEN</option>
                                <option value="IN PROGRESS">IN PROGRESS</option>
                                <option value="COMPLETE"> COMPLETE </option>
                            </select>
                        </div>
                        <button className='filter-apply' onClick={() => { check(); document.getElementsByClassName('showfil')[0].classList.remove('show_hide') }}> Apply </button>
                        {/* <div className='rowfill'><input id='onecheck' type={'checkbox'} /><div onClick={() => setData(tempdat.filter((e) => e.status == 'TODO'))} className='red'>TODO</div></div>
                        <div className='rowfill'><input id='twocheck' type={'checkbox'} /><div onClick={() => setData(tempdat.filter((e) => e.status == 'IN PROGRESS'))} className='yellow'>IN PROGRESS</div></div>
                        <div className='rowfill'><input id='threecheck' type={'checkbox'} /><div onClick={() => setData(tempdat.filter((e) => e.status == 'COMPLETED'))} className='green'>COMPLETED</div></div> */}
                    </div>
                </div>
            </div>
            <div className='Projects top'>
                <div className='ProjectsTop row'>
                    <div className="projleft">Projects</div>
                    <div className="projright row">
                        <button onClick={() => getProjects(false)}>refresh</button>&emsp;
                        {type == 'PROJECT MANAGER' ? <button onClick={() => { setEproj(null); document.getElementsByClassName('showdet')[0].classList.add('show_hide') }} >CREATE</button> : <></>}
                        <div onClick={() => document.getElementsByClassName('showfil')[0].classList.add('show_hide')} className='column'>
                            <svg width="20" height="6" viewBox="0 0 20 6" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M10 5C14.9706 5 19 4.10457 19 3C19 1.89543 14.9706 1 10 1C5.02944 1 1 1.89543 1 3C1 4.10457 5.02944 5 10 5Z" stroke="black" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                            </svg>
                            <svg width="20" height="19" viewBox="0 0 20 19" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M1 1C1 3.23 4.871 7.674 6.856 9.805C7.58416 10.5769 7.99291 11.5959 8 12.657V18L12 16V12.657C12 11.596 12.421 10.582 13.144 9.805C15.13 7.674 19 3.231 19 1" stroke="black" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                            </svg>
                        </div>
                    </div>
                </div>
                <div className='filterList'>
                    {filters.project_name && <Filtertag name={filters.project_name} id='optPnam' />}
                    {filters.project_location && <Filtertag name={filters.project_location} id='optPmem' />}
                    {filters.approx_start_date && <Filtertag name={filters.approx_start_date} id='optRES' />}
                    {filters.approx_duration && <Filtertag name={filters.approx_duration} id='optPAC' />}
                    {filters.status && <Filtertag name={filters.status} id='statop' />}
                </div>
                <div>
                    <table>
                        <tr>
                            <th>PROJECT NAME</th><th>PROJECT LOCATION</th><th>{type != 'CONSULTANT' ?'APPROVED COST':'PROJECT DURATION'}
                                <span onClick={() => {
                                    document.getElementsByClassName('currency')[0].classList.add('show_hide')
                                }
                                } style={{ cursor: 'pointer' }}>
                                    <i class="fas fa-ellipsis-v"></i></span>
                            </th><th>START DATE &emsp;<i title='ascending' onClick={async (e) => {
                                if (e.target.title == 'ascending') {
                                    e.target.style.transform = 'rotate(180deg)';
                                    const upDat = async () => {
                                        setLoad(true)
                                        let dat = await data.sort(function (a, b) {
                                            return new Date(b.approx_start_date) - new Date(a.approx_start_date);
                                        })
                                        setLoad(false)
                                        return dat
                                    }
                                    await setData(await upDat())
                                    e.target.title = 'descending'
                                } else {
                                    e.target.style.transform = 'rotate(0deg)';
                                    const upDat = async () => {
                                        setLoad(true)
                                        let dat = await data.sort(function (a, b) {
                                            return new Date(a.approx_start_date) - new Date(b.approx_start_date);
                                        })
                                        setLoad(false)
                                        return dat
                                    }
                                    await setData(await upDat())
                                    e.target.title = 'ascending'
                                }

                            }} class="fas fa-long-arrow-alt-up UpDownA"></i> </th><th>STATUS</th> {type == 'PROJECT MANAGER' ? <th>EDIT</th> : <></>}
                        </tr>
                        {!load ? data.map((dat) => {
                            return <tr onClick={() => { if (hover) { localStorage.setItem(`project-${dat.slug}`, JSON.stringify(dat)); navigate(`/projectDetails/${dat.slug}`) } }}>
                                <td>{dat.project_name}</td>
                                <td
                                //  className='projmems'
                                >{dat.project_location}

                                    {/* {dat.project_mebers.map((e) => { return e.first_name + " " + e.last_name + ", " })} */}
                                </td><td>{type != 'CONSULTANT' ?numberWithCommas(dat.flyaxavi_approved_coast)+dat.currency:dat.approx_duration}</td>
                                <td>{dat.approx_start_date}</td><td><div className={dat.status == 'OPEN' ? 'red' : dat.status == 'IN PROGRESS' ? 'yellow' : 'green'}>{dat.status}</div></td>
                                {type == 'PROJECT MANAGER' ? <td
                                    onMouseLeave={() => setHover(true)}
                                    onMouseOver={() => setHover(false)}
                                    onClick={async () => {
                                        document.getElementsByClassName('showdet')[0].classList.add('show_hide')
                                        setEproj(dat)
                                    }}>
                                    <i class="fas fa-edit"></i>
                                </td> : <></>}
                            </tr>
                        }) : <>
                            {<TabRen />}
                        </>}
                    </table>
                </div>
            </div>
        </>
    )
}
